import { fetchUserListAPI } from '../../api/fetch-functions/user';
import { IUserType } from '../../types/record/user';
import {
  fetchListFnGenerator,
  fetchSignalStreamGenerator,
  listStreamGenerator
} from './common/zero-id-list';

const fetchSignal$ = fetchSignalStreamGenerator();

/**
 * @description
 * `fetchUserList()`を実行すると`userList$`が発火する．
 */
export const fetchUserList = fetchListFnGenerator(fetchSignal$);

export const userList$ = listStreamGenerator<IUserType>(
  fetchSignal$,
  fetchUserListAPI
);
